import {api} from "../http/apiClient"

const ApiRedirect = () => {
  const verifyRedirects = (params) => {
    return api.post("/redirect/check/", null, {
      params,
    })
  }

  const remindLater = (data) => {
    return api.post("/redirect/remind-later/", data)
  }

  const doNotRemind = (data) => {
    return api.post("/redirect/not-remember/", data)
  }

  const initContact = (data) => {
    return api.post("/redirect/init-contact/", data)
  }

  return {
    verifyRedirects,
    remindLater,
    doNotRemind,
    initContact,
  }
}

export default ApiRedirect
